// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Input, Typography } from "antd";
import { notify } from "@/shared/utils/notify";
import { useEffect } from "react";
import { Controller, FieldErrorsImpl } from "react-hook-form";
import { InputError } from "./styled";

const { TextArea } = Input;
const { Text } = Typography;

interface Props {
  width?: string;
  placeHolder: string;
  name: string;
  label?: string;
  control: any;
  rows?: boolean;
}

interface PropsContents {
  errors: Partial<FieldErrorsImpl<{
    [x: string]: any;
  }>>;
  name: string;
  rows: boolean;
  width: string;
  onChange: (...event: any[]) => void;
  value: any;
  placeHolder: string;
  label?: string;
}

const TextContent = ({ errors, name, rows, onChange, value, width, placeHolder, label }: PropsContents) => {
  useEffect(() => {
    if (errors?.[name]?.message) {
      notify.error(`${errors?.[name]?.message}`)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors])

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        width,
        // height: "80%", // Removido para evitar problemas de layout
        flexDirection: "column",
        marginBottom: 8 // Agregado espaciado inferior seguro
      }}
    >
      {label && (
        <Text style={{ fontSize: 14, fontWeight: 500, marginBottom: 6, color: "#262626", display: "block" }}>
          {label}
        </Text>
      )}
      {!rows ? (
        <Input
          status={errors[name] ? "error" : ""}
          value={value}
          placeholder={placeHolder}
          onChange={onChange}
          style={{ borderRadius: 6 }}
        />
      ) : (
        <TextArea
          status={errors[name] ? "error" : ""}
          value={value}
          placeholder={placeHolder}
          onChange={onChange}
          autoSize={{ minRows: 2, maxRows: 6 }}
          style={{ borderRadius: 6 }}
        />
      )}
      {!!errors[name] && (
        <InputError>{errors?.[name]?.message}</InputError>
      )}
    </div>)
}

export const InputText = ({
  width = "100%",
  placeHolder,
  name,
  label,
  control,
  rows = false,
}: Props) => {
  return (
    <Controller
      shouldUnregister
      control={control}
      name={name}
      render={({ field: { onChange, value = "" }, formState: { errors } }) => {
        return (
          <TextContent 
            placeHolder={placeHolder} 
            errors={errors} 
            name={name} 
            onChange={onChange} 
            rows={rows} 
            value={value} 
            width={width}
            label={label}
          />
        );
      }}
    />
  );
};
